import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { dashboardApi } from "../../api/dashboard";

export default function InvoicesPage() {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const { t, i18n } = useTranslation("dashboard");

  useEffect(() => {
    dashboardApi.getInvoices().then((resp) => setInvoices(resp.data)).finally(() => setLoading(false));
  }, []);

  if (loading) return <p className="text-[#A1A1AA]">{t("invoices.loading")}</p>;

  return (
    <div>
      <h1 className="font-clash text-2xl font-bold text-white mb-6">{t("invoices.heading")}</h1>
      {invoices.length === 0 ? (
        <p className="text-[#A1A1AA]">{t("invoices.empty")}</p>
      ) : (
        <div className="space-y-2">
          {invoices.map((inv) => (
            <div key={inv.id} className="feature-card rounded-lg px-6 py-4 flex items-center justify-between">
              <div>
                <p className="text-white text-sm">${(inv.amount_paid / 100).toFixed(2)} {inv.currency.toUpperCase()}</p>
                <p className="text-xs text-[#A1A1AA]">{new Date(inv.created_at).toLocaleDateString(i18n.language)}</p>
              </div>
              {inv.invoice_url ? (
                <a
                  href={inv.invoice_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-[#FF5500] hover:text-[#FF7733]"
                >
                  {t("invoices.download")}
                </a>
              ) : (
                <span className="text-xs text-[#A1A1AA]">{t("invoices.free")}</span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
